import { UserMedicineRoutes } from 'src/app/core/enums/routes.enum';

export function getLinkToMedicineList(menuId?: string | null): string {
  return menuId ? `${UserMedicineRoutes.List}/${menuId}` : UserMedicineRoutes.Main;
}
